"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAriaLabel = void 0;
/**
 * Created a title case ARIA label for a message based on its type.
 *
 * @param {string} type - The type of the message.
 * @returns {string} The ARIA label for the message in title case.
 */
var getAriaLabel = function (type) {
    var _a;
    if (!type) {
        return 'Message';
    }
    var firstCharacter = (_a = type === null || type === void 0 ? void 0 : type.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var remainingCharacters = type === null || type === void 0 ? void 0 : type.slice(1);
    return "".concat(firstCharacter).concat(remainingCharacters, " Message");
};
exports.getAriaLabel = getAriaLabel;
//# sourceMappingURL=getAriaLabel.js.map